// vim: set ts=2 sw=2 et tw=80 ft=javascript:
/**
 * Copyright (C) 2014, 2015 Minted Inc.
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:IDENTITY
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community': []
})(this, function(m_module, Backbone, $, _) {

  "use strict";
  var M = m_module.M;

  M.View = M.View || {};
  M.View.Community = M.View.Community || {};

  /**
   * @class M.View.Community.DesignerAssetsPromptDialog
   *
   */
  M.View.Community.DesignerAssetsPromptDialog = Backbone.View.extend({

    template: M.Template.Community.DesignerAssetsPrompt,

    events: {
      'click .remindMeLaterButton': 'remindMeLaterButtonClick',
      'click .uploadAssetsButton': 'forwardToAssetUpload'
    },

    initialize: function() {
      M.required(this.options.urlPaths);
      this.$el = $(this.el);
      this.fetchInfoAndDisplayDialog();
    },

    render: function() {
      // Only called if fetchInfoAndDisplayDialog gets info that says
      // dialog should be displayed
      var html = this.template();
      this.$el.html(html);
      this.$el.dialog({
        width: 400,
        modal: true,
        dialogClass: 'designerAssetsPrompt',
        closeOnEscape: false,
        draggable: false,
        resizable: false,
        title: 'you\'re missing images',
        open: function() {
          $(this).parent().find('.ui-dialog-titlebar-close').remove();
        }
      });
      return this;
    },

    remindMeLaterButtonClick: function() {
      // Saves current prompt datetime so designer is not prompted
      // again for a period of time
      this.$el.dialog('close');
      this.saveAssetRequestDateTime(null);
    },

    forwardToAssetUpload: function() {
      // Saves current prompt datetime so designer is not prompted
      // again for a period of time

      // TODO: URL end points are hardcoded because would have to duplicate
      //   on php side. Once off of php, can extract urls into constants in
      //   views/community/designer_asset_management.py and pass in options
      this.saveAssetRequestDateTime(
        this.options.urlPaths['designer_asset_missing_asset_upload']
        + '?source=' + encodeURIComponent(window.location.pathname));
    },

    /**
     * Queries backend to determine if dialog should be shown and
     * displays dialog as needed
     */
    fetchInfoAndDisplayDialog: function() {
      var that = this;
      // Do nothing on error - equivalent to not showing dialog
      $.ajax({
        type: 'GET',
        url: this.options.urlPaths['designer_asset_display_status'],
        success: function(dialogParams) {
          if (dialogParams['showDialog']) {
            that.render();
          }
        }
      });
    },

    /**
     * Saves current asset request prompt date/time to database and
     * redirects user to page if specified
     *
     * Don't handle specific errors, because failure in saving data is
     * an app error that user can't do anything about.
     *
     * @param {string} url to redirect to; null if not redirecting
     */
    saveAssetRequestDateTime: function(forwardUrl) {
      $.ajax({
        type: 'POST',
        url: this.options.urlPaths['designer_asset_last_request_date'],
        success: function() {
          if (forwardUrl) {
            window.location = forwardUrl;
          }
        },
        error: function() {
          if (forwardUrl) {
            window.location = forwardUrl;
          }
        }
      });
    }
  });

  return { };

});
